<template>
    <div>
        <template v-if="ready && breadcrumb">
            <div class="mb-3">
                <Breadcrumb :items="breadcrumb" />
            </div>
        </template>

        <slot />
    </div>
</template>

<script>
  import Breadcrumb from "./ui/Breadcrumb";

  export default {
        components: {
            Breadcrumb
        },
        props: {
            ready: Boolean,
            breadcrumb: Array,
            footerItems: Array,
        }
    }
</script>
